import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "card mb-5 mb-xl-10",
  id: "kt_profile_details_view"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "card-header cursor-pointer" }, [
  /*#__PURE__*/_createVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createVNode("h3", { class: "fw-bolder m-0" }, "Please confirm")
  ])
], -1)
const _hoisted_3 = { class: "card-body p-9" }
const _hoisted_4 = { class: "row mb-7" }
const _hoisted_5 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "First Name/Middle Name/Last Name", -1)
const _hoisted_6 = { class: "col-lg-8" }
const _hoisted_7 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_8 = { class: "row mb-7" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Birth Date", -1)
const _hoisted_10 = { class: "col-lg-8" }
const _hoisted_11 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_12 = { class: "row mb-7" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", { class: "col-lg-4 fw-bold text-muted" }, "Username", -1)
const _hoisted_14 = { class: "col-lg-8" }
const _hoisted_15 = { class: "fw-bolder fs-6 text-dark" }
const _hoisted_16 = {
  key: 0,
  class: "notice d-flex bg-light-warning rounded border-warning border border-dashed  p-6"
}
const _hoisted_17 = { class: "svg-icon svg-icon-2tx svg-icon-warning me-4" }
const _hoisted_18 = { class: "d-flex flex-stack flex-grow-1 " }
const _hoisted_19 = { class: " fw-bold" }
const _hoisted_20 = /*#__PURE__*/_createVNode("h4", { class: "text-gray-800 fw-bolder" }, "BIBO Endorser Registration Confirmation", -1)
const _hoisted_21 = { class: "fs-6 text-gray-600 " }
const _hoisted_22 = {
  key: 0,
  class: "pt-5"
}
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Your original requested upline is ")
const _hoisted_24 = {
  class: "fw-bolder",
  href: "javascript:;"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "pt-5" }, " Please click Submit to proceed. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode("div", _hoisted_6, [
          _createVNode("span", _hoisted_7, _toDisplayString(_ctx.formdata.insured_firstName) + "/" + _toDisplayString(_ctx.formdata.insured_middleName) + "/" + _toDisplayString(_ctx.formdata.insured_lastName), 1)
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode("div", _hoisted_10, [
          _createVNode("span", _hoisted_11, _toDisplayString(_ctx.formdata.insured_birthday), 1)
        ])
      ]),
      _createVNode("div", _hoisted_12, [
        _hoisted_13,
        _createVNode("div", _hoisted_14, [
          _createVNode("span", _hoisted_15, _toDisplayString(_ctx.formdata.username), 1)
        ])
      ]),
      false
        ? (_openBlock(), _createBlock("div", _hoisted_16, [
            _createVNode("span", _hoisted_17, [
              _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Warning-1-circle.svg" })
            ]),
            _createVNode("div", _hoisted_18, [
              _createVNode("div", _hoisted_19, [
                _hoisted_20,
                _createVNode("div", _hoisted_21, [
                  _createTextVNode(_toDisplayString(_ctx.userFname) + ", you are about to register " + _toDisplayString(_ctx.formdata.insured_firstName.toUpperCase()) + " " + _toDisplayString(_ctx.formdata.insured_lastName.toUpperCase()) + " as your BIBO Endorser. ", 1),
                  (_ctx.formdata.uplineid !=  _ctx.formdata.responsedata.actualuplineid)
                    ? (_openBlock(), _createBlock("div", _hoisted_22, [
                        _hoisted_23,
                        _createVNode("a", _hoisted_24, _toDisplayString(_ctx.formdata.responsedata.requesteduplinename) + " (" + _toDisplayString(_ctx.formdata.uplineid) + ") ", 1)
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_25
                ])
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}